import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { NavigationProvider } from "components/navigation/NavigationProvider";
import NotFound from "pages/NotFound";
import RetirementPlanningSetup from './pages/retirement-planning-setup';
import UserRegistration from './pages/user-registration';
import FinancialDashboard from './pages/financial-dashboard';
import LifeGoalsManagement from './pages/life-goals-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <NavigationProvider>
        <ErrorBoundary>
          <ScrollToTop />
          <RouterRoutes>
            {/* Define your route here */}
            <Route path="/" element={<UserRegistration />} />
            <Route path="/retirement-planning-setup" element={<RetirementPlanningSetup />} />
            <Route path="/user-registration" element={<UserRegistration />} />
            <Route path="/financial-dashboard" element={<FinancialDashboard />} />
            <Route path="/life-goals-management" element={<LifeGoalsManagement />} />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </ErrorBoundary>
      </NavigationProvider>
    </BrowserRouter>
  );
};

export default Routes;
